export type WorkflowStatusTab = 'active' | 'inactive' | 'all';

export const WORKFLOW_STATUS_TABS: WorkflowStatusTab[] = ['active', 'inactive', 'all'];

export const statusTabDomain = (tab: WorkflowStatusTab): string => {
  if (tab === 'all') return '[]';
  return `[("active", "=", ${tab === 'active' ? 'True' : 'False'})]`;
};
